module.exports = __webpack_public_path__ + "img/region.6fc9e0c6.png";